export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M17.257 7.007A5 5 0 0 1 17 17H7a5 5 0 0 1-.257-9.993L7 7h10l.257.007ZM7 8.5a3.5 3.5 0 1 0 0 7h10a3.5 3.5 0 1 0 0-7H7ZM17 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"/>
</svg>
`;
